var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPompenaStantsiyaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 34",
    style: {
      enableBackground: "new 0 0 34 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.61,24.88h0.83v0.83h-1.66c0,0,0-7.06,0-8.29c0-1.23,0.46-1.66,1.66-1.66c1.2,0,2.49,0,2.49,0v-2.49 c0,0-0.76,0-3.32,0c-2.55,0-3.32,2.53-3.32,4.15c0,1.61,0,8.29,0,8.29H6.63v-0.83h0.83V19.9H0v0.83h3.32L5.8,31.51h7.46l2.49-10.78 h4.98V19.9h-9.12V24.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.76,19.07h14.1V5.8h-14.1V19.07z M23.63,7.88h4.98v2.49h-4.98V7.88z M17,7.88h4.98v2.49H17V7.88z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.27,
    y: 2.49,
    className: "st0",
    width: 19.9,
    height: 2.49
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.68,
    y: 13.27,
    className: "st0",
    width: 3.32,
    height: 2.49
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPompenaStantsiyaIcon);
export default __webpack_public_path__ + "static/media/pompena_stantsiya_icon.985f0b52.svg";
export { ForwardRef as ReactComponent };